import {CanvasDevice} from '@FormMakerReact/form-maker.types';

export interface FormMakerCanvasProps {
  onContainerReady: (el: HTMLElement) => void;
}

export const DEVICES: readonly CanvasDevice[] = [CanvasDevice.DESKTOP, CanvasDevice.MOBILE];

export const DEVICE_ICON_CLASS: Record<CanvasDevice, string> = {
  [CanvasDevice.DESKTOP]: 'icon-desktop',
  [CanvasDevice.TABLET]: 'icon-ipad',
  [CanvasDevice.MOBILE]: 'icon-mobile',
};

export const DEVICE_LABEL_KEY: Record<CanvasDevice, string> = {
  [CanvasDevice.DESKTOP]: 'pmwjs_form_maker_device_desktop',
  [CanvasDevice.TABLET]: 'pmwjs_form_maker_device_tablet',
  [CanvasDevice.MOBILE]: 'pmwjs_form_maker_device_mobile',
};
